<template lang="pug">
  #app
    main
      header.default-header
        .header-wrap
          .header-top.d-flex.justify-content-between.align-items-center
            .logo
              router-link(to="/")
                img(src='static/img/logo.png')
      transition(name="fade", mode="out-in")
        router-view
      my-footer
</template>

<script>
import Loki from 'lokijs';
import LokiIndexedAdapter from '../node_modules/lokijs/build/loki-indexed-adapter.min';
import Footer from './components/partials/Footer';

export default {
  name: 'App',
  data() {
    return {
      loading: true,
    };
  },
  components: {
    'my-footer': Footer,
  },
  mounted() {
    const idbAdapter = new LokiIndexedAdapter();
    this.$store.sugarData = new Loki('sugardata.db', {
      adapter: idbAdapter,
      autoload: true,
      autoloadCallback: () => {
        if (this.$store.sugarData.getCollection('entries') === null) {
          this.$store.sugarData.addCollection('entries');
        } else {
          const l = this.$store.sugarData.getCollection('entries').find();
          if (l.length) {
            this.$store.firstDate = new Date(l[0].Time);
            this.$store.lastDate = new Date(l[l.length - 1].Time);
          }
        }
        if (this.$store.sugarData.getCollection('events') === null) {
          this.$store.sugarData.addCollection('events');
        }
        if (this.$store.sugarData.getCollection('locations') === null) {
          this.$store.sugarData.addCollection('locations');
        }
        if (this.$store.sugarData.getCollection('meals') === null) {
          this.$store.sugarData.addCollection('meals');
        }
        this.$store.dbLoaded = true;
      },
      autosave: true,
      autosaveInterval: 4000,
    });
    $(document).ready(() => {
      $('select').niceSelect();
      setTimeout(() => {
        this.loading = false;
        $('#loader').addClass('hides');
        $('body').removeClass('unloaded').addClass('loaded');
        setTimeout(() => {
          $('#loader').remove();
          $('#app').trigger('firstLoad');
        }, 250);
      }, 0);
    });
  },
  metaInfo() {
    return {
      titleTemplate: titleChunk => (titleChunk ? `${titleChunk} • Sugar Nanny – ${this.$t('meta.subtitle')}` : `Sugar Nanny • ${this.$t('meta.subtitle')}`),
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
    };
  },
};
</script>

<style lang="stylus">
@import '../node_modules/normalize.css/normalize.css'
@import '../node_modules/bootstrap/dist/css/bootstrap.css'
@import '../static/css/linearicons.css'
@import '../static/css/nice-select.css'
@import '../static/css/theme.css'
@import '../node_modules/line-awesome/dist/css/line-awesome-font-awesome.css'
@import '../node_modules/sweetalert2/dist/sweetalert2.css'
@import 'assets/css/main.styl'

body
  font-size base-font-size
  overflow-x hidden
  -webkit-font-feature-settings 'lnum'
  -moz-font-feature-settings 'lnum'
  font-feature-settings 'lnum'

input:focus
  outline none!important

header
  .logo
    margin-left 10px
    img
      max-height 60px
form
.banner-content
  button.disabled
    opacity .5
    cursor default

.genric-btn
  text-decoration none!important

.skip-btn
  opacity .5
  transition all ease .2s
  &:hover
    opacity 1

.inputfile
  width: 0.1px
  height: 0.1px
  opacity: 0
  overflow: hidden
  position: absolute
  z-index: -1

</style>



// WEBPACK FOOTER //
// src/App.vue